import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-base-circle-plus-filled",
  "use": "rt-base-circle-plus-filled-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rt-base-circle-plus-filled\"><path d=\"M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64z m180 472c0 8.8-7.2 16-16 16H552v124c0 8.8-7.2 16-16 16h-48c-8.8 0-16-7.2-16-16V552H348c-8.8 0-16-7.2-16-16v-48c0-8.8 7.2-16 16-16h124V348c0-8.8 7.2-16 16-16h48c8.8 0 16 7.2 16 16v124h124c8.8 0 16 7.2 16 16v48z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/circle-plus-filled.svg
// module id = 1705
// module chunks = 137